import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import KYC from '../components/kyc';
import * as KycAction from '../actions/kycAction';
function mapStateToProps(state) {
  return {
    poiUrl: state.Chargecard.userInfo.poi_img || '',
    poaUrl: state.Chargecard.userInfo.poa_img || '',
    photoUrl: state.Chargecard.userInfo.photo_img || '',
    minKycDetails: state.Chargecard.userInfo.min_kyc.kyc_details || '',
    addressInfo: state.Kyc.addressInfo || {},
    minKycType:
      state.Kyc.kyc_type || state.Chargecard.userInfo.min_kyc.kyc_type || '',
    kycVideoUrl: state.Kyc.kycVideoLink,
    kycDocType: state.Kyc.kycDocType,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...KycAction,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(KYC);
